

export const TechnicianStyle = () => ({


    technicianStatus: {
        width: "100%",
        height: 97,
        borderRadius: '8px',
        padding: '8px 10px',
        opacity: 1,
        gap: '10px',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0px 0px 2.5px 0px rgba(0, 0, 0, 0.25)',
    },
    iconStyle: {
        opacity: 0.95,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        right: 8,
        top: 8,
    }







})